<template>
    <div  class="container-fluid">

        <h3 class="titreSolu text-center">Changer Mot de passe</h3>

        <div class="row">
            <div class="col-12">
                <input type="number" pattern="[0-9]" onkeydown="javascript: return (event.keyCode == 69 || event.keyCode == 188 || event.keyCode == 190) ? false : true" class="form-control" placeholder="nouveau mot de passe" v-model="mdp" v-on:keyup="changeMDP()" >
            </div>
        </div>
        <br />
        <div class="row">
            <div class="col-12 text-center">
                <button type="button" class="btn btn-primary" @click="saveMDP()" :disabled="mdpValidated">Enregistrer<i
                        aria-hidden="true"></i></button>
            </div>
        </div>
        <div class="row" v-if="changeMsg">
            <div class="col-12 text-center alert" v-bind:class="changeType">
                {{changeMsg}}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Compte",
        props: ['token', 'site', 'user', 'idUser', 'racine', 'listSystemeClient', 'systemClient'],
        data() {
            return {
                aide: '',mdp: null,mdpValidated:true,changeMsg:null,changeType:null
            };
        },
        methods: {
            tokenValide(json) {
                if (json['status'] == '401') {
                    this.token = null
                    this.$emit('token')
                }
            },
            changeMDP()
            {
                this.mdpValidated = false
                this.changeMsg = null

                if(!this.mdp)
                {
                    this.mdpValidated = true
                    this.changeMsg = "Le mot de passe ne doit pas être vide."
                    this.changeType = "alert-danger"
                }
                if(this.mdp.length<4)
                {
                    this.mdpValidated = true
                    this.changeMsg = "Le mot de passe doit avoir au moins 4 caractères."
                    this.changeType = "alert-danger"
                }
                //if(typeof parseInt(this.mdp) !="number")
                /*if(this.mdp.match(/e/g)>0)
                {
                    this.mdp.substring(0, this.mdp.length - 1);
                    this.mdpValidated = true
                    this.changeMsg = "Le mot de passe doit être numérique."
                    this.changeType = "alert-danger"
                }*/

            },
            saveMDP()
            {
                var details = {
                    'password': this.mdp,
                    'plainPassword': this.mdp
                };

                var formBody = [];
                for (var property in details) {
                    var encodedKey = encodeURIComponent(property);
                    var encodedValue = encodeURIComponent(details[property]);
                    formBody.push(encodedKey + "=" + encodedValue);
                }
                formBody = formBody.join("&");

                fetch(this.racine + this.site + 'api/users/'+this.idUser, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    },
                    body: "{\"password\":\"" + this.mdp + "\"," +
                    "\"plainPassword\":\"" + this.mdp + "\"" +
                    "}"
                }).then(response => {
                    console.log(response)
                    this.tokenValide(response)
                    response.json().then(json => {
                        if (json != undefined) {
                            console.log(json);
                            if(this.idUser == json['id'])
                            {
                                this.changeMsg = "Votre mot de passe a bien été changé."
                                this.changeType = "alert-success"
                            }
                        }
                    })
                })
            }
        }
    }
</script>

<style scoped>

</style>